export default __webpack_public_path__ + "static/media/spinner.a4c249eb.gif";